<script>
import Layout from "@/views/layouts/default";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import StarRating from "vue-star-rating";
import Swal from "sweetalert2";
import JobStatus from '@/components/job-status';
import Pusher from "pusher-js";
import { required } from "vuelidate/lib/validators";
import { VMoney } from 'v-money'
import pdf from 'vue-pdf'
import DatePicker from "vue2-datepicker";


/**
 * Advanced table component
 */
export default {
  name: "JobDetail",
  page: {
    title: "Lihat Job",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, StarRating, JobStatus, pdf, DatePicker },
  directives: {
    money: VMoney
  },
  data() {
    return {
      title: "Lihat Job",
      items: [
        {
          text: "Manajemen Job",
          href: "/job"
        },
        {
          text: "Lihat Job",
          active: true
        },
      ],
      reject: {
        cancel_reason: null
      },
      review: {
        target: null,
        target_id: null,
        rating: 0,
        messages: [],
        comment: null,
      },
      job: {},
      submitform: false,
      currentPage: 1,
      totalRows: 0,
      offerings: [],
      isSubmitError: false,
      errorMessage: null,
      isSubmitSuccess: false,
      successMessage: null,
      document: {
        shippingDocuments: [],
        isUploadError: false,
        errorUploadMessage: null,
        isUploadSuccess: false,
        successUploadMessage: null,
      },
      paymentMethod: [],
      listBank: [],
      payment: {
        selectedMethod: null,
        selectedBank: null,
        isPaymentError: false,
        errorPaymentMessage: null,
        isPaymentSuccess: false,
        successPaymentMessage: null,
      },
      creditCard: {
        isPaymentError: false,
        errorPaymentMessage: null,
        isPaymentSuccess: false,
        successPaymentMessage: null,
        number: null,
        cvv: null,
        expire: null,
      },
      mapCenter: {
        lat: -6.914864,
        lng: 107.608238
      },
      markers: [],
      histories: [],
      clipboard: {
        isCopySuccess: false,
        successCopyMessage: null,
      },
      chatRoom: null,
      chats: {
        message: ""
      },
      chatList: [],
      chatListMeta: {
        page: 1,
        per_page: 10,
        orderby: 'created_at',
        sort: 'desc',
        total_page: 0,
      },
      documentType: "",
      documentsDO: [],
      offeringRange: {
        minimal: "",
        maksimal: "",
      },
      money: {
        decimal: ',',
        thousands: '.',
        precision: 0,
      },
      setting: {
        admin_fee: 0,
        platform_fee: 0
      },
      preview: {
        type: "",
        src: ""
      },
      apiUrl: process.env.VUE_APP_BASE_URL_API
    };
  },
  validations() {
    return {
      reject: {
        cancel_reason: { required }
      },
      review: {
        comment: { required }
      },
      chats: {
        message: { required }
      },
      offeringRange: {
        maksimal: {
          minVal: value => {
            if (this.offeringRange.minimal === "") {
              return this.convertToAngka(value) >= 0
            } else {
              return this.convertToAngka(value) >= this.convertToAngka(this.offeringRange.minimal)
            }
          }
        }
      },
      creditCard: {
        number: { required },
        cvv: { required },
        expire: { required },
      },
    }
  },
  computed: {
    paymentMethodTransfer() {
      return this.paymentMethod.find(item => item.type === 'bank_transfer')
    },
    paymentMethodCreditCard() {
      return this.paymentMethod.find(item => item.type === 'credit_card')
    },
    paymentMethodGopay() {
      return this.paymentMethod.find(item => item.type === 'gopay')
    },
    availablePaymentMethods() {
      const methods = [];
      for (let i = 0; i < this.paymentMethod.length; i++) {
        const tod = this.paymentMethod[i];
        if (tod.has_children) {
          for (let y = 0; y < this.listBank.length; y++) {
            const bank = this.listBank[y];
            if (bank.payment_method == tod.type) {
              methods.push({
                type: bank.payment_method,
                name: bank.name,
                logo: bank.logo ? this.apiUrl+bank.logo : require('@/assets/images/default-image.jpg'),
                slug: bank.slug
              })
            }
          }
        } else {
          methods.push({
            type: tod.type,
            name: tod.name,
            logo: tod.logo ? this.apiUrl+tod.logo : require('@/assets/images/default-image.jpg'),
            slug: tod.type
          })
        }
      }
      return methods;
    },
    titleModalRating() {
      if (this.review.target == 'driver') {
        return 'Berikan Rating Driver'
      } else if (this.review.target == 'truck_owner') {
        return 'Berikan Rating Truck Owner'
      }else {
        return '-'
      }
    },
    canRateDriver() {
      let can = false;
      if (this.job.status == 11) {
        const ratingDriver = this.job.ratings.findIndex(item => item.target.toLowerCase() === 'driver')
        if (ratingDriver < 0) {
          can = true
        }
      }
      return can;
    },
    canRateTruckOwner() {
      let can = false;
      if (this.job.status == 11 && this.job.truck_owner !== null) {
        const ratingTruckOwner = this.job.ratings.findIndex(item => item.target.toLowerCase() === 'truck_owner')
        if (ratingTruckOwner < 0) {
          can = true
        }
      }
      return can;
    },
    refund() {
      const job = this.job.offer_price !== undefined ? this.job.offer_price : 0
      const discount = Math.floor(30 / 100 * this.job.offer_price)
      const total = job - discount
      return total - Math.floor(2.5 / 100 * total)
    }
  },
  watch: {
    currentPage() {
      this.getOffering()
    },
  },
  created() {
    this.getDetail()
    this.getOffering()
    this.getPaymentMethod()
    this.getBank()
    this.getSetting()
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      console.log('Modal is about to be shown', bvEvent, modalId)
      // modal payment
      this.payment.isPaymentError = false
      this.payment.isPaymentSuccess = false
      // modal document
      this.document.isUploadError = false
      this.document.isUploadSuccess = false
      // modal virtual account
      this.clipboard.isCopySuccess = false
      // root
      this.isSubmitSuccess = false
      this.isSubmitError = false
      // load chat
      this.chatList = [],
      this.chatListMeta ={
        page: 1,
        per_page: 10,
        orderby: 'created_at',
        sort: 'desc',
        total_page: 0,
      }
    })
    this.subscribe()
    this.handlePermission()
  },
  methods: {
    getPaymentMethod() {
      this.$axios.get('/v1/payment_method')
        .then(response => {
          this.paymentMethod = response.data.data
        })
    },
    getBank() {
      this.$axios.get('/v1/bank')
        .then(response => {
          this.listBank = response.data.data
        })
    },
    getOffering() {
      this.$axios.get(`/v1/logistic_company/job/${this.$route.params.id}/offer`, {
        params: {
          page: this.currentPage,
          per_page: 4,
          orderby: 'id',
          sort: 'desc',
          offer_price_min: this.offeringRange.minimal !== null && this.offeringRange.minimal !== "" ? this.convertToAngka(this.offeringRange.minimal) : null,
          offer_price_max: this.offeringRange.maksimal !== null && this.offeringRange.maksimal !== "" ? this.convertToAngka(this.offeringRange.maksimal) : null,
        }
      }).then(response => {
        this.offerings = response.data.data.rows
        this.totalRows = response.data.data.total_data
      })
    },
    getDetail() {
      this.$axios.get(`/v1/logistic_company/job/${this.$route.params.id}`)
        .then(response => {
          this.job = response.data.data
          if (response.data.data.documents) {
            this.document.shippingDocuments = response.data.data.documents
          }
          this.markers = this.job.addresses.map(item => {
            return {
              id: item.id,
              lat: Number(item.lat),
              lng: Number(item.lng),
              type: item.type,
            }
          })
          this.title = `Lihat Job <span class="badge badge-danger badge-pill ml-3">${this.job.code}</span>`
        })
        .catch(error => {
          if (error.response.status == 404) {
            this.$router.push('/404')
          }
        })
    },
    submitCancelJob() {
      this.$v.$touch();
      if (!this.$v.reject.$invalid) {
        window.scrollTo(0,0);
        if (this.job.status >= 4 && this.job.type === 'external') {
          this.$refs.modalCancel.hide();
          this.$refs.modalCancelAfterPayment.show()
        } else {
          this.$refs.modalCancel.hide();
          this.cancelJob()
        }
      }
    },
    cancelJob() {
      this.$axios.put(`/v1/logistic_company/job/${this.$route.params.id}/cancel`, {
        cancel_reason: this.reject.cancel_reason
      })
      .then(response => {
        this.isSubmitSuccess = true
        this.isSubmitError = false
        this.successMessage = response.data.message
        this.getDetail()
        this.$refs.modalCancelAfterPayment.hide()
      }).catch(error => {
        this.isSubmitSuccess = false
        this.isSubmitError = true
        this.errorMessage = error.response.data.message
      })
    },
    uploadDocument(event) {
      console.log(event)
      if(event.target.files[0] !== undefined){
        let extension = event.target.files[0].name.split(".").pop()
        let allowedExtention = ['jpg','jpeg','png','pdf']
        if(allowedExtention.includes(extension.toLowerCase())){
          let param = new FormData();
          param.append('file', event.target.files[0])
          param.append('status', 'active') 
          param.append('title', event.target.name)
          param.append('description', 'document')

          this.$axios.post('/v1/admin/media', param)
            .then(response => {
              this.document.shippingDocuments.push({
                name: event.target.files[0].name.split(".")[0],
                file_path: response.data.data.file
              })
              this.submitShippingDocument()
            })

        }else{
          this.document.isUploadError = true
          this.document.errorUploadMessage = "file extentions not allowed"
        }
      }
    },
    submitShippingDocument() {
      this.$axios.put(`/v1/logistic_company/job/${this.job.id}/documents`, {
        documents: this.document.shippingDocuments
      })
        .then(response => {
          this.document.isUploadSuccess = true
          this.document.isUploadError = false
          this.document.successUploadMessage = response.data.message
        })
        .catch(error => {
          this.document.isUploadSuccess = false
          this.document.isUploadError = true
          this.document.errorUploadMessage = error.response.data.message
        })
    },
    removeDocument(index) {
      this.document.shippingDocuments.splice(index, 1);
      this.$axios.put(`/v1/logistic_company/job/${this.job.id}/documents?delete=1`, {
        documents: this.document.shippingDocuments
      })
        .then(response => {
          console.log(response.data);
          this.document.isUploadSuccess = true
          this.document.isUploadError = false
          this.document.successUploadMessage = 'Berhasil menghapus dokumen'
        })
        .catch(error => {
          console.log(error)
          this.document.isUploadSuccess = false
          this.document.isUploadError = true
          this.document.errorUploadMessage = 'Gagal menghapus dokumen'
        })
    },
    confirmAcceptOffering(offer) {
      Swal.fire({
        title: "Anda yakin akan menerima tawaran ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#06f826",
        cancelButtonColor: "#6c757d",
        cancelButtonText: "Batal",
        confirmButtonText: "Ya"
      }).then(result => {
        if (result.value) {
          this.$axios.post(`/v1/logistic_company/job/${this.job.id}/accept_offer`, {
            job_offer_id: offer.id
          })
          .then(response => {
            this.isSubmitSuccess = true
            this.isSubmitError = false
            this.successMessage = response.data.message
            this.getDetail()
          }).catch(error => {
            this.isSubmitSuccess = false
            this.isSubmitError = true
            this.errorMessage = error.response.data.message
          })
        }
      });
    },
    setPaymentMethod(method) {
      this.payment.selectedMethod = method.type
      this.payment.selectedBank = method.slug
    },
    submitPayment() {
      if (this.payment.selectedMethod) {
        if (this.payment.selectedMethod === 'credit_card') {
          this.$refs.modalPayment.hide()
          this.$refs.modalCreditCard.show()
        } else {
          let urlPayment = '';
          if (this.job.status == 10) {
            urlPayment = `/v1/logistic_company/job/${this.job.id}/pay_additional_price`
          } else {
            urlPayment = `/v1/logistic_company/job/${this.job.id}/pay`
          }
          this.$axios.post(urlPayment, {
            payment_method: this.payment.selectedMethod,
            bank: this.payment.selectedBank
          })
          .then(response => {
            this.payment.isPaymentSuccess = true
            this.payment.isPaymentError = false
            this.payment.successPaymentMessage = response.data.message
            setTimeout(async () => {
              await this.getDetail()
              this.$refs.modalPayment.hide()
              if (this.payment.selectedMethod == 'gopay') {
                this.$refs.modalQrCode.show()
              }
              if (this.payment.selectedMethod == 'bank_transfer') {
                this.$refs.modalVirtualAccount.show()
              }
              if (this.payment.selectedMethod == 'direct_debit') {
                this.$refs.modalDirectDebit.show()
              }
              if (this.payment.selectedMethod == 'akulaku') {
                this.$refs.modalCredit.show()
              }
              if (this.payment.selectedMethod == 'convenience_store') {
                this.$refs.modalConvenienceStore.show()
              }
            }, 2000)
          }).catch(error => {
            this.payment.isPaymentSuccess = false
            this.payment.isPaymentError = true
            this.payment.errorPaymentMessage = error.response.data.message
          })
        }
      } else {
        this.payment.isPaymentError = true
        this.payment.errorPaymentMessage = 'Anda harus memilih payment method terlebih dahulu'
      }
    },
    submitCreditCard() {
      this.$v.$touch();
      if (!this.$v.creditCard.$invalid) {
        // card data from customer input, for example
        const expired = this.creditCard.expire.split('-')
        var cardData = {
          "card_number": this.creditCard.number,
          "card_exp_month": expired[0],
          "card_exp_year": expired[1],
          "card_cvv": this.creditCard.cvv,
        };
        
        // callback functions
        var options = {
          onSuccess: (response) => {
            // Success to get card token_id, implement as you wish here
            console.log('Success to get card token_id, response:', response);
            var token_id = response.token_id;
        
            console.log('This is the card token_id:', token_id);
            // Implement sending the token_id to backend to proceed to next step
            let urlPayment = '';
            if (this.job.status == 10) {
              urlPayment = `/v1/logistic_company/job/${this.job.id}/pay_additional_price`
            } else {
              urlPayment = `/v1/logistic_company/job/${this.job.id}/pay`
            }
            this.$axios.post(urlPayment, {
              payment_method: this.payment.selectedMethod,
              token_cc: token_id
            })
            .then(response => {
              this.creditCard.isPaymentSuccess = true
              this.creditCard.isPaymentError = false
              this.creditCard.successPaymentMessage = response.data.message
              setTimeout(() => {
                this.getDetail()
                this.$refs.modalCreditCard.hide()
                console.log(response.data)
              }, 2000)
            }).catch(error => {
              this.payment.isPaymentSuccess = false
              this.payment.isPaymentError = true
              this.payment.errorPaymentMessage = error.response.data.message
            })
          },
          onFailure: (response) => {
            // Fail to get card token_id, implement as you wish here
            console.log('Fail to get card token_id, response:', response);
        
            // you may want to implement displaying failure message to customer.
            // Also record the error message to your log, so you can review
            // what causing failure on this transaction.
            this.creditCard.isPaymentSuccess = false
            this.creditCard.isPaymentError = true
            this.creditCard.successPaymentMessage = 'Gagal memproses kartu kredit'
          }
        };
        
        // trigger `getCardToken` function
        // eslint-disable-next-line no-undef
        MidtransNew3ds.getCardToken(cardData, options);
      }
    },
    finishJob() {
      window.scrollTo(0,0);
      this.$refs.modalFinish.hide();
      this.$axios.put(`/v1/logistic_company/job/${this.$route.params.id}/finish`)
      .then(response => {
        this.isSubmitSuccess = true
        this.isSubmitError = false
        this.successMessage = response.data.message
        this.getDetail()
      }).catch(error => {
        this.isSubmitSuccess = false
        this.isSubmitError = true
        this.errorMessage = error.response.data.message
      })
    },
    showFormRating(target) {
      this.review.target = target
      if (target === 'driver') {
        this.review.target_id = this.job.driver.id
      } else {
        this.review.target_id = this.job.truck_owner.id
      }
      this.$refs.modalRating.show()
    },
    addReviewMessage(message) {
      const checkMessage = this.review.messages.findIndex(item => item === message);
      if (checkMessage < 0) {
        this.review.messages.push(message);
      } else {
        this.review.messages.splice(checkMessage, 1);
      }
    },
    checkReviewMessage(message) {
      const checkMessage = this.review.messages.findIndex(item => item === message);
      if (checkMessage < 0) {
        return 'outline-dark'
      } else {
        return 'success'
      }
    },
    submitRating() {
      this.$v.$touch();
      if (!this.$v.review.$invalid) {
        window.scrollTo(0,0);
        this.$refs.modalRating.hide();
        this.$axios.post(`/v1/logistic_company/job/${this.$route.params.id}/rate`, this.review)
        .then(response => {
          this.isSubmitSuccess = true
          this.isSubmitError = false
          this.successMessage = response.data.message
          this.getDetail()
        }).catch(error => {
          this.isSubmitSuccess = false
          this.isSubmitError = true
          this.errorMessage = error.response.data.message
        })
      }
    },
    startChat(user_id, role) {
      this.$axios.post('/v1/chat_job', {
        job_id: this.job.id,
        user_id: user_id
      })
        .then(response => {
          console.log(role)
          console.log(response.data);
          this.chatRoom = response.data.data
          this.getListChat()
          this.$refs.modalChat.show();
          this.scrollChat()
        }).catch(error => {
          this.isSubmitSuccess = false
          this.isSubmitError = true
          this.errorMessage = error.response.data.message
        })
    },
    getLastLocation() {
      this.$axios.get(`v1/logistic_company/job/${this.$route.params.id}/tracking`)
        .then(response => {
          this.histories = response.data.data.histories
          this.$refs.modalTracking.show()
          if (
            response.data.data.lat !== null && response.data.data.lat !== "" &&
            response.data.data.lng !== null && response.data.data.lng !== ""
          ) {
            const checkLiveMarker = this.markers.findIndex(item => item.id === undefined)
            if (checkLiveMarker < 0) {
              this.markers.push({
                lat: Number(response.data.data.lat),
                lng: Number(response.data.data.lng),
                type: 'live',
              })
            } else {
              this.markers[checkLiveMarker] = {
                lat: Number(response.data.data.lat),
                lng: Number(response.data.data.lng),
                type: 'live',
              }
            }
            this.$nextTick(() => {
              //set bounds of the map
              this.$refs.gmap.$mapPromise.then((map) => {
                map.setCenter({
                  lat: Number(response.data.data.lat),
                  lng: Number(response.data.data.lng),
                })
                map.setZoom(15)
              });
            })
          } else {
            //set bounds of the map
            this.$nextTick(() => {
              this.$refs.gmap.$mapPromise.then((map) => {
                // eslint-disable-next-line no-undef
                const bounds = new google.maps.LatLngBounds()
                for (let m of this.markers) {
                  bounds.extend({
                    lat: m.lat, 
                    lng: m.lng
                  })
                }
                map.fitBounds(bounds);
                map.setZoom(15)
              });
            })
          }
        }).catch(error => {
          console.log(error)
        })
    },
    setIconMarker(type) {
      let icon = ""
      if (type === 'dropoff') {
        icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
      } else if (type === 'pickup') {
        icon = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
      } else {
        icon = require("@/assets/images/pin-truck.png");
      }
      return icon
    },
    handlePermission() {
      navigator.permissions.query({ name: 'geolocation' })
        .then((result) => {
          console.log(result);
        });
      navigator.geolocation.getCurrentPosition((position) => {
        this.mapCenter = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      });
    },
    copyText(elementId, message) {
      const element = document.getElementById(elementId)
      navigator.clipboard.writeText(element.innerText);
      this.clipboard = {
        isCopySuccess: true,
        successCopyMessage: message
      }
      this.isSubmitSuccess = true;
      this.successMessage = message
    },
    subscribe () {
      const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, { cluster: process.env.VUE_APP_PUSHER_CLUSTER })
      pusher.subscribe(`user-${this.$store.state.userdata.id}`)
      pusher.bind('chat-job', (data) => {
        console.log(data)
        if (data !== undefined) {
          const checkMessage = this.chatList.findIndex(item => item.id === data.id)
          if (checkMessage < 0) {
            this.chatList.push(data)
          }
        }
      })
    },
    async getListChat() {
      try {
        const response = await this.$axios.get(`/v1/chat_job/${this.chatRoom.id}`, {
          params: {
            ...this.chatListMeta,
            role: this.job.truck_owner !== null ? 'truck_owner' : 'driver'
          }
        })

        if (response.data.data.rows !== undefined && response.data.data.rows.length > 0) {
          for (let index = 0; index < response.data.data.rows.length; index++) {
            const message = response.data.data.rows[index];
            this.chatList.unshift(message)
          }
          //this.chatList = [...response.data.data.rows, ...this.chatList].reverse()
          this.chatListMeta.page = Number(response.data.data.current_page)
          this.chatListMeta.per_page = response.data.data.per_page
          this.chatListMeta.total_page = Number(response.data.data.total_page)
        }
        
      } catch (error) {
        console.log(error);
      }
    },
    loadMore() {
      if (this.chatListMeta.total_page > this.chatListMeta.page) {  
        this.chatListMeta.page = this.chatListMeta.page + 1
        this.getListChat()
      }
    },
    sendMessage() {  
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.chats.$invalid) {
        return;
      } else {
        this.$axios.post(`/v1/chat_job/${this.chatRoom.id}`, {
          message: this.chats.message
        })
          .then(response => {
            this.chats.message = ""
            this.$v.$reset();
            this.chatList.push(response.data.data)
            this.scrollChat()
          })
      }
    },
    uploadAttachment(event) {
      if(event.target.files[0] !== undefined){
        let extension = event.target.files[0].name.split(".").pop()
        let allowedExtention = ['jpg','jpeg','png']
        if(allowedExtention.includes(extension.toLowerCase())){
          let param = new FormData();
          param.append('file', event.target.files[0])
          param.append('status', 'active') 
          param.append('title', event.target.name)
          param.append('description', 'document')

          this.$axios.post('/v1/admin/media', param)
            .then(response => {
              this.$axios.post(`/v1/chat_job/${this.chatRoom.id}`, {
                file_type: 'image',
                file_path: response.data.data.file
              })
                .then(response => {
                  this.chats.message = ""
                  this.$v.$reset();
                  document.getElementById('attachment').value = null
                  this.chatList.push(response.data.data)
                })
            })

        }else{
          this.document.isUploadError = true
          this.document.errorUploadMessage = "file extentions not allowed"
        }
      }
    },
    scrollChat() {
      let child = document.getElementsByClassName("clearfix");
      console.log(child);
      console.log(child.length);
      if (child && child.length) {
        child[child.length - 1].scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    },
    setDocumentDeliveryOrder(address, documentType) {
      this.documentType = documentType
      this.documentsDO = []
      if (address.photos) {
        this.documentsDO = this.documentsDO.concat(address.photos)
      }
      if (address.documents) {
        this.documentsDO = this.documentsDO.concat(address.photos)
      }
      this.$refs.modalDokumenDelivery.show()
    },
    filterOffering() {
      this.$v.$touch();
      if (!this.$v.offeringRange.$invalid) {
        if (this.currentPage == 1) {
          this.getOffering()
        } else {
          this.currentPage = 1
        }
      }
    },
    resetFilterOfering() {
      this.offeringRange = {
        minimal: "",
        maksimal: "",
      }
      this.$v.$reset();      
      if (this.currentPage == 1) {
        this.getOffering()
      } else {
        this.currentPage = 1
      }
    },
    confirmFinishJob() {
      if (this.job.additional_price === null || this.job.additional_price === 0 || this.job.type === 'internal') {
        this.$refs.modalFinish.show()
      } else {
        if (this.job.additional_price_paid === true) {
          this.$refs.modalFinish.show()
        } else {
          this.$refs.modalAdditionalPrice.show()
        }
      }
    },
    payAdditionalPrice() {
      this.$refs.modalAdditionalPrice.hide();
      this.$refs.modalPayment.show()
    },
    getSetting() {
      this.$axios.get('/v1/setting')
      .then(response => {
        if (response.data.data.type === 'setting') {
          this.setting = response.data.data.setting
        }
      })
    },
    previewDoc(doc) {
      const extention = doc.split(".").pop()
      this.preview = {
        type: extention,
        src: doc
      }
      this.$refs.modalDocument.show()
    },
    redirectToPaymentUrl() {
      this.$refs.modalCredit.hide()
      this.$refs.modalDirectDebit.hide()
      window.open(this.job.transaction.payment_detail.redirect_url, '_blank')
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              v-model="isSubmitSuccess"
              class="mt-3"
              variant="success"
              dismissible
            >{{ successMessage }}</b-alert>

            <b-alert
              v-model="isSubmitError"
              class="mt-3"
              variant="danger"
              dismissible
            >{{errorMessage}}</b-alert>

            <div class="row">
              <div class="col-lg-5">
                <h5 class="mb-3">Detail Job</h5>
                <div class="row">
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">No</label>
                    <p class="font-weight-bolder mb-0">{{ job.code }}</p>
                    <br />
                    <label class="mb-0 form-label font-weight-light">Tanggal Pickup</label>
                    <p class="font-weight-bolder mb-0">{{ job.start_date | date_time }}</p>
                    <br />
                    <label class="mb-0 form-label font-weight-light">Kategori</label>
                    <p class="font-weight-bolder mb-0" v-if="job.armada_category">{{ job.armada_category.name }}</p>
                    <br />
                  </div>
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">Tanggal Posting</label>
                    <p class="font-weight-bolder mb-0">{{ job.published_at | date_only }}</p>
                    <br />
                    <label class="mb-0 form-label font-weight-light">Estimasi Sampai</label>
                    <p class="font-weight-bolder mb-0">{{ job.end_date | date_time }}</p>
                    <br />
                    <template v-if="job.offer_price && job.status >= 3">
                      <label class="mb-0 form-label font-weight-light">Deal Harga</label>
                      <p class="font-weight-bolder mb-0">IDR {{ job.offer_price | convertToRupiah }}</p>
                      <br />
                    </template>
                  </div>
                  <div class="col-lg-6" v-if="job.offer_price && job.status >= 3">
                    <label class="mb-0 form-label font-weight-light">Admin Fee</label>
                    <p class="font-weight-bolder mb-0">IDR {{ setting.admin_fee | convertToRupiah }}</p>
                    <br />
                  </div>
                  <div class="col-lg-6" v-if="job.offer_price && job.status >= 3">
                    <label class="mb-0 form-label font-weight-light">Total Bayar</label>
                    <p class="font-weight-bolder mb-0">IDR {{ Number(job.offer_price) + Number(setting.admin_fee) | convertToRupiah }}</p>
                    <br />
                  </div>
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">Status</label>
                    <JobStatus :status="job.status" v-if="job.status_publish == 'published'" />
                    <p class="font-weight-bolder mb-0 text-secondary" v-if="job.status_publish == 'draft'">
                      Draft
                    </p>
                    <br />
                  </div>
                  <div class="col-lg-6" v-if="(job.cancel_at >= 4 && job.status == 12 && job.type == 'external')">
                    <label class="mb-0 form-label font-weight-light" v-if="(job.cancel_at >= 7)">
                      Job anda dibatalkan dan anda pendapatkan pengembalian dana sebesar
                      <span class="font-weight-bolder text-secondary">
                        Rp. {{ refund | convertToRupiah }}
                      </span>
                    </label>
                    <label class="mb-0 form-label font-weight-light" v-if="(job.cancel_by.role_id > 3 || job.cancel_at <= 6)">
                      Job anda dibatalkan dan anda pendapatkan pengembalian dana sebesar
                      <span class="font-weight-bolder text-secondary">
                        Rp. {{ job.offer_price - Math.floor(2.5 / 100 * job.offer_price) | convertToRupiah }}
                      </span>
                    </label>
                  </div>
                  <div class="col-lg-12">
                    <template v-if="(job.additional_price !== null && job.additional_price > 0)">
                      <label class="mb-0 form-label font-weight-light">Biaya Tambahan</label>
                      <p class="font-weight-bolder mb-0">IDR {{ job.additional_price | convertToRupiah }}</p>
                      <br />
                      <template v-if=" job.additional_price_paid === false">
                        <label class="mb-0 form-label font-weight-light text-danger">
                          Driver melakukan pengajuan penambahan biaya 
                        </label>
                        <br />
                        <b-link class="text-danger font-weight-bolder" @click="$refs.modalAdditionalPrice.show()">
                          <u>Lihat detail pengajuan</u>
                        </b-link>
                        <br /><br />
                      </template>
                    </template>
                    <b-button v-if="job.status >= 5 && job.status <= 11" class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalDokumen.show()">Lihat Dokumen Pengiriman</b-button>
                  </div>
                  <!-- informasi pembayaran -->
                  <div class="col-lg-12" v-if="(job.transaction !== null && job.transaction !== undefined)">
                    <div v-if="job.transaction.status === 'Pending' && job.status !== 12">
                      <label class="mb-0 form-label font-weight-light">
                        Dimohon segera melakukan pembayaran sebelum
                      </label>
                      <p class="font-weight-bolder mb-0 text-merah">
                        {{ job.transaction.payment_expired_at | date_time }}
                      </p>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'mandiri'">
                        Kode Billing
                        <span  @click="copyText('kode_billing_mandiri', 'berhasil mengcopy no kode billing ke clipboard')" id="kode_billing_mandiri" class="font-weight-medium cursor-pointer">
                          {{ job.transaction.payment_detail.biller_code }}
                          <i class="ti ti-files float-right"></i>
                        </span>
                        <br />
                        No Virtual Account
                        <span  @click="copyText('va_bank_mandiri', 'berhasil mengcopy no virtual account ke clipboard')" id="va_bank_mandiri" class="font-weight-medium cursor-pointer">
                          {{ job.transaction.payment_detail.bill_key }}
                          <i class="ti ti-files float-right"></i>
                        </span>
                        <br />
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'permata'">
                        Ke Virtual Account Bank {{ job.transaction.bank.toUpperCase() }}
                        <span @click="copyText('va_bank', 'berhasil mengcopy no virtual account ke clipboard')" id="va_bank" class="font-weight-medium cursor-pointer">
                          {{ job.transaction.payment_detail.permata_va_number }}
                          <i class="ti ti-files float-right"></i>
                        </span>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'bca' || job.transaction.bank === 'bni' || job.transaction.bank === 'bri'">
                        Ke Virtual Account Bank {{ job.transaction.bank.toUpperCase() }}
                        <span @click="copyText('va_bank', 'berhasil mengcopy no virtual account ke clipboard')" id="va_bank" class="font-weight-medium cursor-pointer">
                          {{ job.transaction.payment_detail.va_numbers[0].va_number }}
                          <i class="ti ti-files float-right"></i>
                        </span>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'bca_klikpay'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalDirectDebit.show()">
                          Klik disini untuk melakukan proses pembayaran BCA KlikPay
                        </b-button>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'cimb_clicks'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalDirectDebit.show()">
                          Klik disini untuk melakukan proses pembayaran CIMB Click
                        </b-button>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'danamon_online'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalDirectDebit.show()">
                          Klik disini untuk melakukan proses pembayaran Danamon Online
                        </b-button>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'bri_epay'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalDirectDebit.show()">
                          Klik disini untuk melakukan proses pembayaran BRI Epay
                        </b-button>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'akulaku'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalCredit.show()">
                          Klik disini untuk melakukan proses pembayaran Akulaku
                        </b-button>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'credit_card'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalCredit.show()">
                          Klik disini untuk melakukan proses pembayaran Credit Card
                        </b-button>
                      </div>

                      <div class="mb-0 w-100 form-label font-weight-light" v-if="job.transaction.bank === 'indomaret' | job.transaction.bank === 'alfamart'">
                        <b-link class="font-weight-bolder cursor-pointer" @click="$refs.modalConvenienceStore.show()">
                          Kode Pembayaran {{ job.transaction.bank | capitalize }}
                          <span id="payment_code" class="font-weight-medium cursor-pointer">
                            {{ job.transaction.payment_detail.payment_code }}
                          </span>
                        </b-link>
                      </div>
                      
                      <div class="mb-0 form-label font-weight-light" v-if="job.transaction.payment_method === 'gopay'">
                        <b-button class="mb-3" type="button" size="sm" variant="danger" @click="$refs.modalQrCode.show()">Tampilkan QR Code Pembayaran</b-button>
                      </div>
                      <br />
                    </div>
                  </div>
                  <div class="col-lg-12"  v-if="job.status == 12">
                    <label class="mb-0 form-label font-weight-light">Alasan Pembatalan</label>
                    <p class="font-weight-bolder mb-0">{{ job.cancel_reason || '-' }}</p>
                    <br />
                  </div>
                </div>
                <b-card bg-variant="light" border-variant="secondary" class="shadow-lg addresses mt-3">
                  <b-card-text>
                    <div class="mb-3" v-for="(address, index) in job.addresses" :key="index">
                      <b-button v-if="(address.photos !== null || address.documents !== null) && address.type == 'pickup'" class="float-right" type="button" variant="outline-secondary" size="sm" @click="setDocumentDeliveryOrder(address, 'Dokumen Delivery Order')">
                        Delivery Order
                      </b-button>
                      <b-button v-if="(address.photos !== null || address.documents !== null) && address.type == 'dropoff'" class="float-right" type="button" variant="outline-secondary" size="sm" @click="setDocumentDeliveryOrder(address, 'Dokumen POD')">
                        POD
                      </b-button>
                      <p class="font-weight-medium mb-0" :class="[ address.type == 'pickup' ? 'text-danger' : 'text-success']">{{ address.type | capitalize }}</p>
                      <p class="font-weight-bolder font-size-18 mb-0">{{ address.name }} - {{ address.phone_number }}</p>
                      <p class="font-weight-medium mb-0">{{ address.address }}</p>
                      <span>{{ address.address_detail }}</span>
                    </div>
                  </b-card-text>
                </b-card>
                <h5 class="mb-3">Detail Paket</h5>
                <div class="row">
                  <div class="col-lg-12">
                    <label class="mb-0 form-label font-weight-light">Kategori Barang</label>
                    <p class="font-weight-bolder mb-0">{{ job.package_name }}</p>
                    <br />
                  </div>
                  <div class="col-lg-4">
                    <label class="mb-0 form-label font-weight-light">Berat</label>
                    <p class="font-weight-bolder mb-0">{{ job.package_weight }} Kg</p>
                    <br />
                  </div>
                  <div class="col-lg-4">
                    <label class="mb-0 form-label font-weight-light">Volume</label>
                    <p class="font-weight-bolder mb-0">{{ job.package_volume }} m3</p>
                    <br />
                  </div>
                  <div class="col-lg-4">
                    <label class="mb-0 form-label font-weight-light">Koli</label>
                    <p class="font-weight-bolder mb-0">{{ job.package_koli }} Pcs</p>
                    <br />
                  </div>
                  <div class="col-lg-12">
                    <label class="mb-0 form-label font-weight-light">Note</label>
                    <p class="font-weight-bolder mb-0">{{ job.package_note }}</p>
                    <br />
                  </div>
                </div>
                <template v-if="job.status >= 10">
                  <h5 class="mb-3">Detail Resi</h5>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-light">Expedisi</label>
                      <p class="font-weight-bolder mb-0">{{ job.expedition || '-' }}</p>
                      <br />
                    </div>
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-light">No Resi</label>
                      <p class="font-weight-bolder mb-0">{{ job.resi_number || '-' }}</p>
                      <br />
                    </div>
                    <div class="col-lg-12 mb-3" v-if="job.resi_path">
                      <b-button class="mb-3" type="button" size="sm" variant="danger" @click="previewDoc(job.resi_path)">Lihat Dokumen Resi</b-button>
                    </div>
                  </div>
                </template>
                <h5 class="mb-3">Info PIC</h5>
                <div class="row">
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">Nama</label>
                    <p class="font-weight-bolder mb-0">{{ job.pic_name }}</p>
                    <br />
                  </div>
                  <div class="col-lg-6">
                    <label class="mb-0 form-label font-weight-light">Telepon</label>
                    <p class="font-weight-bolder mb-0">{{ job.pic_phone }}</p>
                    <br />
                  </div>
                </div>
              </div>
              <div class="col-lg-7 border-kiri">
                <template v-if="job.status <= 2">
                  <h5 class="mb-3">
                    Kandidat Driver
                    <span class="float-right font-size-16">Penawaran ({{ totalRows }})</span>
                  </h5>
                  <b-form @submit.prevent="filterOffering">
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="form-group mb-3">
                          <b-form-group id="minimal_bid_group" label="Penawaran Minimal" label-for="minimal_bid">
                            <b-form-input
                              id="minimal_bid"
                              name="minimal_bid"
                              v-model="offeringRange.minimal"
                              type="text"
                              v-money="money"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <div class="form-group mb-3">
                          <b-form-group id="maksimal_bid_group" label="Penawaran Maksimal" label-for="maksimal_bid">
                            <b-form-input
                              id="maksimal_bid"
                              name="maksimal_bid"
                              :class="{ 'is-invalid': $v.offeringRange.maksimal.$error }"
                              v-model="offeringRange.maksimal"
                              type="text"
                              v-money="money"
                            ></b-form-input>
                            <div v-if="$v.offeringRange.maksimal.$error" class="invalid-feedback">
                              <span v-if="!$v.offeringRange.maksimal.minVal">{{ $t('form.validation.min_value', { field: 'Penawaran Maksimal', label: '0 dan Penawaran Minimal' }) }}</span>
                            </div>
                          </b-form-group>
                        </div>
                      </div>
                      <div class="col-lg-6 pt-4">
                        <b-button type="submit" variant="success" class="mr-2">Cari</b-button>
                        <b-button type="button" variant="danger" @click="resetFilterOfering">Reset Pencarian</b-button>
                      </div>
                    </div>
                  </b-form>
                  <div id="list-driver pt-2" style="height: 650px" v-if="offerings.length">
                    <b-card class="border border-dark shadow-lg" v-for="(offer, index) in offerings" :key="index">
                      <b-card-text>
                        <div class="d-inline-flex w-100">
                          <div class="avatar">
                            <img :src="offer.owner_detail.profile_picture" alt="male" class="avatar-md rounded-circle mr-2" />
                          </div>
                          <div class="driver-info w-100 ml-3 d-flex justify-content-between">
                            <div class="info" style="max-width: 70%">
                              <p class="mb-0 font-weight-bolder d-inline">
                                {{ offer.owner_detail.name }}
                                <star-rating :increment="0.5" :inline="true" :rating="Number(offer.owner_detail.rating)" :star-size="23" :read-only="true" class="ml-3"></star-rating>
                              </p>
                              <p class="mb-0">
                                {{ offer.owner_detail.address }}
                              </p>
                              <p class="text-primary font-weight-medium">
                                {{ offer.job_this_week }} Job minggu ini
                              </p>
                              <p class="font-weight-bolder mb-0">
                                IDR {{ offer.offer_price | convertToRupiah }}
                              </p>
                            </div>
                            <div class="action-driver py-4">
                              <b-button type="button" variant="warning" class="text-dark mr-2" 
                                :class="{ negosiasi: offer.last_message_at !== null }" 
                                @click="startChat(offer.user_id, offer.owner)"
                              >Negosiasi</b-button>
                              <b-button type="button" variant="success" @click="confirmAcceptOffering(offer)">Pilih</b-button>
                            </div>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card>
                    <div class="row">
                      <div class="col-lg-12 d-flex justify-content-center">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="10"></b-pagination>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row border-radius py-3 m-3 cursor-pointer" v-if="offerings.length == 0">
                    <div class="col-sm-12 text-center font-size-24">
                      Belum ada penawaran untuk Job ini
                    </div>
                  </div>
                </template>
                <template v-if="job.status > 2">
                  <h5 class="mb-3">Driver Terpilih</h5>
                  <div class="row" v-if="job.truck_owner !== null">
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-owner font-size-16">
                        Truck Owner {{ job.truck_owner.name }}
                      </label>
                      <p class="font-weight-bolder mb-0">
                        {{ job.truck_owner.address }}
                      </p>
                      <p class="font-weight-bolder mb-0">
                        {{ job.truck_owner.email }}
                      </p>
                      <br />
                    </div>
                    <div class="col-lg-6 border-kiri pl-4">
                      <label class="mb-0 form-label font-weight-light">Alamat Pool</label>
                      <p class="font-weight-bolder mb-0">
                        {{ job.truck_owner.pool_address }}
                      </p>
                      <br />
                      <label class="mb-0 form-label font-weight-light">Telepon</label>
                      <p class="font-weight-bolder mb-0">
                        {{ job.truck_owner.phone }}
                      </p>
                      <br />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="mb-0 form-label font-weight-owner font-size-18">Driver</label>
                      <template v-if="job.driver === null">
                        <p v-if="job.status == 3" class="font-weight-bolder mb-0">Menunggu Pembayaran Selesai</p>
                        <p v-if="job.status == 4 && job.type == 'external'" class="font-weight-bolder mb-0">Menunggu Assign Driver Oleh Truck Owner</p>
                        <p v-if="job.status == 4 && job.type == 'internal'" class="font-weight-bolder mb-0">Menunggu Assign Driver</p>
                      </template>
                      <template v-else>
                        <div class="row">
                          <div class="col-lg-6">
                            <label class="mb-0 form-label font-weight-light">No KTP</label>
                            <p class="font-weight-bolder mb-0">{{ job.driver.ktp ? job.driver.ktp.ktp_no : '-' }}</p>
                            <br />
                            <label class="mb-0 form-label font-weight-light">No SIM</label>
                            <p class="font-weight-bolder mb-0">{{ job.driver.sim ? job.driver.sim.sim_no : '-' }}</p>
                            <br />
                          </div>
                          <div class="col-lg-6">
                            <label class="mb-0 form-label font-weight-light">Nama</label>
                            <p class="font-weight-bolder mb-0">{{ job.driver.name }}</p>
                            <br />
                            <label class="mb-0 form-label font-weight-light">Telepon</label>
                            <p class="font-weight-bolder mb-0">{{ job.driver.phone }}</p>
                            <br />
                            <label class="mb-0 form-label font-weight-light">Alamat</label>
                            <p class="font-weight-bolder mb-0">{{ job.driver.address }}</p>
                            <br />
                          </div>
                          <template v-if="job.status <= 11">
                            <b-button v-if="job.truck_owner !== null" @click="startChat(job.truck_owner.user_id, 'truck_owner')" type="button" variant="success" class="ml-2">Chat Truck Owner</b-button>
                            <b-button v-else @click="startChat(job.driver.user_id, 'driver')" type="button" variant="success" class="ml-2">Chat Driver</b-button>
                          </template>
                        </div>
                      </template>
                      <br />
                    </div>
                    <div class="col-lg-6 border-kiri pl-4">
                      <label class="mb-0 form-label font-weight-owner font-size-18">Armada</label>
                      <template v-if="job.armada === null">
                        <p v-if="job.status == 3" class="font-weight-bolder mb-0">Menunggu Pembayaran Selesai</p>
                        <p v-if="job.status == 4 && job.type == 'external'" class="font-weight-bolder mb-0">Menunggu Assign Armada Oleh Truck Owner</p>
                        <p v-if="job.status == 4 && job.type == 'internal'" class="font-weight-bolder mb-0">Menunggu Assign Armada</p>
                      </template>
                      <template v-else>
                        <div class="row">
                          <div class="col-lg-6">
                            <label class="mb-0 form-label font-weight-light">No STNK</label>
                            <p class="font-weight-bolder mb-0">{{ job.armada.stnk_number }}</p>
                            <br />
                            <label class="mb-0 form-label font-weight-light">Merk</label>
                            <p class="font-weight-bolder mb-0">{{ job.armada.merk }}</p>
                            <br />
                            <label class="mb-0 form-label font-weight-light">Warna</label>
                            <p class="font-weight-bolder mb-0">{{ job.armada.color }}</p>
                            <br />
                          </div>
                          <div class="col-lg-6">
                            <label class="mb-0 form-label font-weight-light">No Plat</label>
                            <p class="font-weight-bolder mb-0">{{ job.armada.plat_number }}</p>
                            <br />
                            <label class="mb-0 form-label font-weight-light">Tipe</label>
                            <p class="font-weight-bolder mb-0">{{ job.armada_category.name }}</p>
                            <br />
                          </div>
                        </div>
                      </template>
                      <br />
                    </div>
                  </div>
                </template>
                <div class="action">
                  <b-button to="/job" class="mr-2 btn-light">Kembali</b-button>
                  <b-button v-if="job.status == 4 && job.type == 'internal'" :to="`/job/${job.id}/edit`" type="button" variant="outline-danger" class="mr-2">Edit</b-button>
                  <b-button v-if="job.status <= 3" :to="`/job/${job.id}/edit`" type="button" variant="outline-danger" class="mr-2">Edit</b-button>
                  <template v-if="job.status_publish == 'published'">
                    <b-button v-if="job.status == 3 && job.type == 'external'" @click="$refs.modalPayment.show()" type="button" variant="success" class="mr-2">Bayar</b-button>
                    <b-button v-if="job.status == 10" @click="confirmFinishJob"  type="button" variant="success" class="mr-2">Selesai</b-button>
                    <b-button v-if="canRateDriver" @click="showFormRating('driver')"  type="button" variant="warning" class="mr-2">Rating Driver</b-button>
                    <b-button v-if="canRateTruckOwner" @click="showFormRating('truck_owner')"  type="button" variant="warning" class="mr-2">Rating Truck Owner</b-button>
                    <b-button v-if="job.status >= 6 && job.status <= 11" @click="getLastLocation" type="button" variant="primary" class="mr-2">Tracking</b-button>
                    <b-button v-if="job.status <= 7"  @click="$refs.modalCancel.show()" type="button" variant="danger">Batalkan</b-button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- modal batalkan -->
    <b-modal title="Batalkan Job ?" ref="modalCancel" id="modal-cancel" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-form @submit.prevent="submitCancelJob">
        <b-form-group id="reason-group" label="Alasan Pembatalan" label-for="reason">
          <b-textarea
            id="reason"
            name="reason"
            v-model="reject.cancel_reason"
            :class="{ 'is-invalid': $v.reject.cancel_reason.$error }"
            rows="5"
          ></b-textarea>
          <div v-if="$v.reject.cancel_reason.$error" class="invalid-feedback">
            <span v-if="!$v.reject.cancel_reason.required">{{ $t('form.validation.required', { field: 'Alasan Pembatalan' }) }}</span>
          </div>
        </b-form-group>
        <b-button type="submit" variant="danger">Ya</b-button>
        <b-button type="button" class="ml-2 btn-light" @click="$refs.modalCancel.hide()">Batal</b-button>
      </b-form>
    </b-modal>
    <!-- /.modal -->

    <!-- modal batalkan job after payment -->
    <b-modal title="Batalkan Job ?" ref="modalCancelAfterPayment" id="modal-cancel" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="text-center px-2">
        <p>Apakah Anda yakin akan batalkan job?</p>
        <p v-if="(job.status <= 6)">
          Jika YA anda akan mendapatkan pengembalian dana 100% dari nilai job
        </p>
        <p v-if="(job.status >= 7)">
          Jika YA anda akan mendapatkan pengembalian dana 70% dari nilai job 
          dan 30% kompensasi pembatalan untuk Truck Driver/ Truck Owner
        </p>
        <b-button type="button" variant="danger" @click="cancelJob">Ya</b-button>
        <b-button type="button" class="ml-2 btn-light" @click="$refs.modalCancelAfterPayment.hide()">Batal</b-button>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal selesai -->
    <b-modal title="Job telah Selesai?" ref="modalFinish" id="modal-finish" hide-footer no-close-on-esc no-close-on-backdrop>
      <p class="text-center">
        Apakah Anda yakin barang dan dokumen yang Anda kirim telah sesuai dan sampai ditujuan ?
      </p>
      <b-button type="button" variant="danger" @click="finishJob">Ya</b-button>
      <b-button type="button" class="ml-2 btn-light" @click="$refs.modalFinish.hide()">Batal</b-button>
    </b-modal>
    <!-- /.modal -->

    <!-- modal rating -->
    <b-modal :title="titleModalRating" ref="modalRating" id="modal-rating-driver" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-form @submit.prevent="submitRating">
        <div class="text-center rating">
          <star-rating v-model="review.rating" :increment="1" :show-rating="false" :rounded-corners="true" :padding="10" :inline="true"></star-rating>
        </div>
        <div class="default-comment mt-3 d-flex align-items-center justify-content-around">
          <b-button @click="addReviewMessage('ketepatan waktu')" :variant="checkReviewMessage('ketepatan waktu')" type="button" class="border-radius-2">ketepatan waktu</b-button>
          <b-button @click="addReviewMessage('kelengkapan administrasi')" :variant="checkReviewMessage('kelengkapan administrasi')" type="button" class="border-radius-2">kelengkapan administrasi</b-button>
          <b-button @click="addReviewMessage('komunikasi lancar')" :variant="checkReviewMessage('komunikasi lancar')" type="button" class="border-radius-2">komunikasi lancar</b-button>
        </div>
        <div class="default-comment mt-3 d-flex align-items-center justify-content-around">
          <b-button @click="addReviewMessage('armada dalam keadaan baik')" :variant="checkReviewMessage('armada dalam keadaan baik')" type="button" class="border-radius-2">armada dalam keadaan baik</b-button>
          <b-button @click="addReviewMessage('penyelesaian masalah baik')" :variant="checkReviewMessage('penyelesaian masalah baik')" type="button" class="border-radius-2">penyelesaian masalah baik</b-button>
        </div>
        <b-form-group id="comment-group" label="" label-for="comment" class="mt-3">
          <b-textarea
            id="comment"
            name="comment"
            placeholder="Komentar"
            v-model="review.comment"
            :class="{ 'is-invalid': $v.review.comment.$error }"
            rows="5"
          ></b-textarea>
          <div v-if="$v.review.comment.$error" class="invalid-feedback">
            <span v-if="!$v.review.comment.required">{{ $t('form.validation.required', { field: 'Komentar' }) }}</span>
          </div>
        </b-form-group>
        <div class="text-center">
          <b-button type="submit" variant="danger">Kirim</b-button>
        </div>
      </b-form>
    </b-modal>
    <!-- /.modal -->

    <!-- modal upload dokumen -->
    <b-modal title="Dokumen Pengiriman oleh LC" ref="modalDokumen" id="modal-dokumen" size="lg" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-alert
        v-model="document.isUploadSuccess"
        class="mt-3"
        variant="success"
        dismissible
      >{{ document.successUploadMessage }}</b-alert>
      <b-alert
        v-model="document.isUploadError"
        class="mt-3"
        variant="danger"
        dismissible
      >{{ document.errorUploadMessage }}</b-alert>
      <div class="row">
        <div class="col-lg-3" v-for="(doc, index) in document.shippingDocuments" :key="index">
          <i class="mdi mdi-trash-can-outline font-size-24 remove-document" v-if="job.status <= 7" @click="removeDocument(index)"></i>
          <b-link href="#" @click="previewDoc(doc.file_path)">
            <b-img v-if="doc.file_path.split('.').pop() != 'pdf'" fluid :src="doc.file_path" :alt="doc.name" />
            <b-img v-else :src="require('@/assets/images/services-icon/pdf_icon.png')" height="130" :alt="doc.name" />
          </b-link>
          <p>{{ doc.name | capitalize }}</p>
        </div>
      </div>
      <div class="text-center mt-3" v-if="job.status <= 7">
        <input type="file" name="dokumen_pengiriman" ref="dokumen" @change="uploadDocument" class="d-none" accept=".pdf, .jpg, .png, .jpeg" />
        <b-button type="button" variant="danger" class="ml-2" @click="$refs.dokumen.click()">Upload Dokumen Baru</b-button>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal payment -->
    <b-modal title="Pilih Methode Pembayaran" ref="modalPayment" id="modal-payment" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-alert
        v-model="payment.isPaymentSuccess"
        class="mt-3"
        variant="success"
        dismissible
      >{{ payment.successPaymentMessage }}</b-alert>
      <b-alert
        v-model="payment.isPaymentError"
        class="mt-3"
        variant="danger"
        dismissible
      >{{ payment.errorPaymentMessage }}</b-alert>
      <div class="row">
        <div
          v-for="(method, index) in availablePaymentMethods"
          :key="index"
          class="col-lg-12 mb-3 border rounded p-2 payment-method"
          :class="{ active: payment.selectedMethod == method.type && payment.selectedBank == method.slug }"
          @click="setPaymentMethod(method)"
        >
          <div class="d-flex justify-content-start align-items-center">
            <b-img :src="method.logo" width="75" />
            <p class="font-size-20 ml-3">
              {{ method.name }}
            </p>
          </div>
        </div>
        <div class="w-100 d-flex justify-content-around">
          <b-button type="button" class="w-50" variant="danger" @click="submitPayment">Ya</b-button>
          <b-button type="button" class="ml-2 w-50 btn-light" @click="$refs.modalPayment.hide()">Batal</b-button>
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal QR Code -->
    <b-modal v-if="job.transaction !== undefined && job.transaction !== null" title="Pembayaran Melalui Gopay" ref="modalQrCode" id="modal-qr-code" size="sm" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row" v-if="job.transaction.payment_method == 'gopay'">
        <div class="col-lg-12">
          <p v-if="job.transaction.payment_method_detail" v-html="job.transaction.payment_method_detail.instruction"></p>
        </div>
        <div class="col-lg-12">
          <b-link :href="job.transaction.payment_detail.actions[1].url" target="_blank" v-b-tooltip.hover title="Klik untuk membuka aplikasi gojek">
            <b-img :src="job.transaction.payment_detail.actions[0].url" fluid alt="gopay" />
          </b-link>
        </div>
      </div>
      <div class="text-center mt-3">
        <b-button type="button" class="ml-2 btn-light" @click="$refs.modalQrCode.hide()">Tutup</b-button>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal Virtual Account -->
    <b-modal v-if="job.transaction !== undefined && job.transaction !== null" title="Virtual Account" ref="modalVirtualAccount" id="modal-virtual-account" size="sm" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row" v-if="job.transaction.payment_method == 'bank_transfer'">
        <div class="col-lg-12">
          <b-alert
            v-model="clipboard.isCopySuccess"
            class="mt-3"
            variant="success"
            dismissible
            @dismiss-count-down="5"
            @dismissed="clipboard.isCopySuccess = false"
          >{{ clipboard.successCopyMessage }}</b-alert>
          <label class="mb-0 form-label font-weight-light">
            Dimohon segera melakukan pembayaran sebelum
          </label>
          <p class="font-weight-bolder mb-0 text-merah">
            {{ job.transaction.payment_expired_at | date_time }}
          </p>
          <label class="mb-0 w-100 form-label font-weight-light">
            Ke Virtual Account Bank {{ job.transaction.bank.toUpperCase() }}
            <div v-if="job.transaction.bank === 'mandiri'">
              Kode Billing
              <p @click="copyText('billing_popup', 'berhasil mengcopy no kode billing ke clipboard')" id="billing_popup" class="font-weight-medium cursor-pointer">
                {{ job.transaction.payment_detail.biller_code }}
                <i class="ti ti-files float-right"></i>
              </p>
              <br />
              No Virtual Account
              <p @click="copyText('va_bank_mandiri_popup', 'berhasil mengcopy no virtual account ke clipboard')" id="va_bank_mandiri_popup" class="font-weight-medium cursor-pointer">
                {{ job.transaction.payment_detail.bill_key }}
                <i class="ti ti-files float-right"></i>
              </p>
              <br />
            </div>
            <div v-if="job.transaction.bank === 'permata'">
              <p @click="copyText('va_bank_popup', 'berhasil mengcopy no virtual account ke clipboard')" id="va_bank_popup" class="font-weight-medium cursor-pointer w-100 font-size-20">
                {{ job.transaction.payment_detail.permata_va_number }}
                <i class="ti ti-files float-right"></i>
              </p>
            </div>
            <div v-if="job.transaction.bank === 'bca' || job.transaction.bank === 'bni' || job.transaction.bank === 'bri'">
              <p @click="copyText('va_bank_popup', 'berhasil mengcopy no virtual account ke clipboard')" id="va_bank_popup" class="font-weight-medium cursor-pointer w-100 font-size-20">
                {{ job.transaction.payment_detail.va_numbers[0].va_number }}
                <i class="ti ti-files float-right"></i>
              </p>
            </div>
          </label>
          <br />
          <p v-if="job.transaction.bank_detail" v-html="job.transaction.bank_detail.instruction"></p>
        </div>
      </div>
      <div class="text-center mt-3">
        <b-button type="button" class="ml-2 btn-light" @click="$refs.modalVirtualAccount.hide()">Tutup</b-button>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal Convenience Store -->
    <b-modal v-if="job.transaction !== undefined && job.transaction !== null" title="Pembayaran Melalui Merchant" ref="modalConvenienceStore" id="modal-convenience-store" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row" v-if="job.transaction.payment_method == 'convenience_store'">
        <div class="col-lg-12">
          <b-alert
            v-model="clipboard.isCopySuccess"
            class="mt-3"
            variant="success"
            dismissible
            @dismiss-count-down="5"
            @dismissed="clipboard.isCopySuccess = false"
          >{{ clipboard.successCopyMessage }}</b-alert>
          <label class="mb-0 form-label font-weight-light">
            Dimohon segera melakukan pembayaran sebelum
          </label>
          <p class="font-weight-bolder mb-0 text-merah">
            {{ job.transaction.payment_expired_at | date_time }}
          </p>
          <label class="mb-0 w-100 form-label font-weight-light">
            Merchant {{ job.transaction.payment_detail.store | capitalize }}
            <div>
              Kode Pembayaran
              <p @click="copyText('payment_code_convenience_store', 'berhasil mengcopy kode pembayaran ke clipboard')" id="payment_code_convenience_store" class="font-weight-medium text-merah">
                {{ job.transaction.payment_detail.payment_code }}
              </p>
            </div>
          </label>
          <br />
          <p v-if="job.transaction.bank_detail" v-html="job.transaction.bank_detail.instruction"></p>
        </div>
      </div>
      <div class="mt-3">
        <div class="w-100 d-flex justify-content-around">
          <b-button type="button" class="w-50" variant="danger" @click="copyText('payment_code_convenience_store', 'berhasil mengcopy no kode pembayaran ke clipboard')">Copy Kode Pembayaran</b-button>
          <b-button type="button" class="ml-2 w-50 btn-light" @click="$refs.modalConvenienceStore.hide()">Tutup</b-button>
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal Direct Debit -->
    <b-modal v-if="job.transaction !== undefined && job.transaction !== null" title="Pembayaran Melalui Direct Debit" ref="modalDirectDebit" id="modal-direct-debit" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row" v-if="job.transaction.payment_method == 'direct_debit'">
        <div class="col-lg-12">
          <p v-if="job.transaction.bank_detail" v-html="job.transaction.bank_detail.instruction"></p>
        </div>
      </div>
      <div class="mt-3">
        <div class="w-100 d-flex justify-content-around">
          <b-button type="button" class="w-50" variant="danger" @click="redirectToPaymentUrl">Bayar Sekarang</b-button>
          <b-button type="button" class="ml-2 w-50 btn-light" @click="$refs.modalDirectDebit.hide()">Tutup</b-button>
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal Payment Instruction Credit -->
    <b-modal v-if="job.transaction !== undefined && job.transaction !== null" title="Pembayaran Melalui Kredit" ref="modalCredit" id="modal-credit" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row" v-if="job.transaction.payment_method == 'akulaku' || job.transaction.payment_method == 'credit_card'">
        <div class="col-lg-12">
          <p v-if="job.transaction.payment_method_detail" v-html="job.transaction.payment_method_detail.instruction"></p>
        </div>
      </div>
      <div class="mt-3">
        <div class="w-100 d-flex justify-content-around">
          <b-button type="button" class="w-50" variant="danger" @click="redirectToPaymentUrl">Bayar Sekarang</b-button>
          <b-button type="button" class="ml-2 w-50 btn-light" @click="$refs.modalCredit.hide()">Tutup</b-button>
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal credit card -->
    <b-modal title="Silahkan isi informasi kartu kredit Anda" ref="modalCreditCard" id="modal-credit-card" hide-footer no-close-on-esc no-close-on-backdrop>
      <b-alert
        v-model="creditCard.isPaymentSuccess"
        class="mt-3"
        variant="success"
        dismissible
      >{{ creditCard.successPaymentMessage }}</b-alert>
      <b-alert
        v-model="creditCard.isPaymentError"
        class="mt-3"
        variant="danger"
        dismissible
      >{{ creditCard.errorPaymentMessage }}</b-alert>
      <form @submit.prevent="submitCreditCard">
        <div class="row">
          <div class="col-lg-12">
            <b-form-group id="cc_number-group" label="No Kartu Kredit" label-for="cc_number">
              <b-form-input
                id="cc_number"
                name="cc_number"
                v-model.trim="creditCard.number"
                :class="{ 'is-invalid': $v.creditCard.number.$error }"
                type="text"
              ></b-form-input>
              <div v-if="$v.creditCard.number.$error" class="invalid-feedback">
                <span v-if="!$v.creditCard.number.required">{{ $t('form.validation.required', { field: 'No Kartu Kredit' }) }}</span>
              </div>
            </b-form-group>
            <div class="form-group mb-3">
              <label>Kadaluarsa</label>
              <date-picker
                id="pickup-date"
                name="expireCreditCard"
                type="month"
                format="MMMM YYYY"
                value-type="MM-YYYY"
                v-model.trim="creditCard.expire"
                :class="{ 'is-invalid': $v.creditCard.expire.$error }"
              ></date-picker>
              <div v-if="$v.creditCard.expire.$error" class="invalid-feedback">
                <span v-if="!$v.creditCard.expire.required">{{ $t('form.validation.required', { field: 'Kadaluarsa' }) }}</span>
              </div>
            </div>
            <b-form-group id="cc_cvv-group" label="CVV" label-for="cc_cvv">
              <b-form-input
                id="cc_cvv"
                name="cc_cvv"
                v-model.trim="creditCard.cvv"
                :class="{ 'is-invalid': $v.creditCard.cvv.$error }"
                type="password"
              ></b-form-input>
              <div v-if="$v.creditCard.cvv.$error" class="invalid-feedback">
                <span v-if="!$v.creditCard.cvv.required">{{ $t('form.validation.required', { field: 'CVV' }) }}</span>
              </div>
            </b-form-group>
          </div>
          <div class="w-100 d-flex justify-content-around">
            <b-button type="submit" class="w-50" variant="danger">Ya</b-button>
            <b-button type="button" class="ml-2 w-50 btn-light" @click="$refs.modalCreditCard.hide()">Batal</b-button>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- /.modal -->

    <!-- modal Tracking -->
    <b-modal title="Live Tracking" ref="modalTracking" id="modal-tracking" size="xl" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-8">
          <div id="map-container" class="border border-dark">
            <GmapMap
              ref="gmap"
              :center="mapCenter"
              :zoom="13"
              map-type-id="terrain"
              style="width: 100%; height: 100%"
            >
              <GmapMarker
                :key="index"
                v-for="(marker, index) in markers"
                :position="{ lat: marker.lat, lng: marker.lng }"
                :icon="setIconMarker(marker.type)"
              />
            </GmapMap>
          </div>
        </div>
        <div class="col-lg-4 border-kiri">
          <div id="history-container">
            <ul>
              <li v-for="(history, index) in histories" :key="index">
                <div v-for="(status, zindex) in history.status_text" :key="zindex">
                  <p v-if="status.owner == 'lc'" class="font-weight-bolder mb-0" :class="{ 'text-danger': index === 0 }">
                    {{ status.status_text | capitalize }}
                  </p>
                </div>
                <p class="font-size-11 text-secondary">{{ history.created_at | date_time }}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal Chat -->
    <b-modal ref="modalChat" id="modal-chat" size="md" hide-footer no-close-on-esc no-close-on-backdrop>
      <template slot="modal-title" v-if="chatRoom">
        <h4 v-if="chatRoom.user_1_role === 'logistic_company'">
          <img :src="chatRoom.user_2.profile_picture" alt="male" class="avatar-xs rounded-circle" />
          {{ chatRoom.user_2.full_name }}
        </h4>
        <h4 v-if="chatRoom.user_2_role === 'logistic_company'">
          <img :src="chatRoom.user_1.profile_picture" alt="male" class="avatar-xs rounded-circle" />
          {{ chatRoom.user_1.full_name }}
        </h4>
      </template>
      <div class="row">
        <div class="col-lg-12">
          <div class="chat-conversation">
            <ul class="conversation-list" id="messagesContainer" v-scroll="loadMore">
              <li
                v-for="chat in chatList"
                :key="chat.id"
                :class="{'odd': chat.sender_id === $store.state.userdata.id }"
                class="clearfix"
              >
                <div class="conversation-text">
                  <div class="ctext-wrap">
                    <b-img v-if="chat.file_path" fluid style="max-height: 400px" :src="chat.file_path" />
                    <p>{{ chat.message }}</p>
                    <span class="time">{{ chat.created_at | time_only }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <form @submit.prevent="sendMessage">
            <div class="row pt-3">
              <div class="col-sm-8 col-7 chat-inputbar">
                <input
                  id="message"
                  v-model="chats.message"
                  type="text"
                  class="form-control chat-input"
                  placeholder="Tulis pesan Anda"
                  name="message"
                  :class="{ 'is-invalid': $v.chats.message.$error }"
                />
                <div
                  v-if="!$v.chats.message.required"
                  class="invalid-feedback"
                >{{ $t('form.validation.required', { field: 'Pesan' }) }}.</div>
              </div>

              <div class="col-sm-2 col-2 chat-send">
                <button type="button" class="btn btn-light btn-block" @click="$refs.attachment.click()">
                  <i class="ti-clip"></i>
                </button>
                <input type="file" id="attachment" name="attachment" ref="attachment" @change="uploadAttachment" class="d-none" accept=".jpg, .jpeg, .png" />
              </div>

              <div class="col-sm-2 col-3 chat-send">
                <b-button type="submit" variant="danger" class="btn btn-block">Kirim</b-button>
              </div>
            </div>
            <!-- end row -->
          </form>
          <!-- end form -->
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal delivery dokument -->
    <b-modal :title="documentType" ref="modalDokumenDelivery" id="modal-dokumen-delivery" size="lg" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-3" v-for="(doc, index) in documentsDO" :key="index">
          <b-link href="#" @click="previewDoc(doc.path)">
            <b-img v-if="doc.path.split('.').pop() != 'pdf'" fluid :src="doc.path" :alt="doc.name" />
            <b-img v-else :src="require('@/assets/images/services-icon/pdf_icon.png')" height="130" :alt="doc.name" />
          </b-link>
          <p>{{ doc.name | capitalize }}</p>
        </div>
      </div>
    </b-modal>
    <!-- /.modal -->

     <!-- modal tambahan biaya -->
     <b-modal title="Permintaan Tambahan Biaya" ref="modalAdditionalPrice" id="modal-additional-price" size="lg" hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="row">
        <div class="col-lg-3">
          <label class="mb-0 form-label font-weight-light">Tambahan Biaya</label>
          <p class="font-weight-bolder mb-0" v-if="job.additional_price">{{ job.additional_price | convertToRupiah }}</p>
          <br />
        </div>
        <div class="col-lg-3">
          <label class="mb-0 form-label font-weight-light">Keterangan</label>
          <p class="font-weight-bolder mb-0">-</p>
          <br />
        </div>
      </div>
      <div class="row" v-if="job.invoice_path">
        <div class="col-lg-12 text-center">
          <b-link target="_blank" :href="job.invoice_path">
            <b-img fluid style="max-height: 400px" :src="job.invoice_path" />
          </b-link>
        </div>
      </div>
      <div class="text-right mt-3">
        <b-button type="button" class="ml-2 btn-light" @click="$refs.modalAdditionalPrice.hide()">
          Kembali
        </b-button>
        <b-button v-if="(!job.additional_price_paid && job.type !== 'internal' && job.status < 12)" type="button" variant="danger" class="ml-2" @click="payAdditionalPrice">
          Bayar & Selesaikan Job
        </b-button>
      </div>
    </b-modal>
    <!-- /.modal -->

    <!-- modal preview document -->
    <b-modal title="Preview" ref="modalDocument" id="modal-document" size="lg" hide-footer>
      <div class="row">
        <div class="col-lg-12 text-center">
          <b-link :href="preview.src" target="_blank">
            <pdf v-if="preview.type === 'pdf'" :src="preview.src"></pdf>
            <b-img v-else fluid :src="preview.src"></b-img>
          </b-link>
        </div>
      </div>
    </b-modal>
    <!-- / modal-->
  </Layout>
</template>

<style lanng="scss" scoped>
.action {
  position: absolute;
  bottom: 0;
  right: 15px;
}

.addresses {
  height: 350px;
  overflow-y: auto;
}

.conversation-list {
  list-style: none;
  padding: 0px 10px;
  max-height: 350px;
}

.remove-document {
  position: absolute;
  right: 20px;
  color: red;
  cursor: pointer;
}

.payment-method:hover {
  border: 1px solid red !important;
  color: red;
  cursor: pointer;
}

.active {
  border: 1px solid red !important;
  color: red;
  cursor: pointer;
}

#map-container {
  height: 600px;
}
#history-container {
  height: 600px;
  overflow-y: scroll;
}
#messagesContainer {
  height: 300px;
  overflow-y: scroll;
}

.negosiasi {
  position: relative;
}
.negosiasi::after {
  content: attr(data-badge);
  position: absolute;
  top: -7px;
  right: -9px;
  font-size: 0.51em;
  background: #e53935;
  color: white;
  width: 15px;
  height: 15px;
  text-align: center;
  line-height: 18px;
  border-radius: 50%;
}
</style>